<script lang="ts" setup>
import { computed, watch } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';

import { useTripPlannerViewModel } from '@apps/main/modules/tripPlannerViewModel/TripPlannerViewModel';
import { TripPlannerRoute } from '@apps/main/modules/router/tripPlannerRoute';

import { useRouterStore } from '../new-desktop/core/stores/routerStore';
import { useMetaStore } from '../new-desktop/core/stores';
import type { TripPlannerProperties } from '../modules/router/propsRouteBuilder/legacy/model';
import { useRecipeStore } from '../new-desktop/core/stores/recipe/recipeStore';
import { usePreferredTimeStore } from '../new-desktop/core/stores/preferredTimeStore';

const props = defineProps<TripPlannerProperties>();
const router = useRouter();

const recipeStore = useRecipeStore();
const preferredTimeStore = usePreferredTimeStore();
const { preferredDay, preferredMonth } = storeToRefs(preferredTimeStore);
const routerStore = useRouterStore();
const metaStore = useMetaStore();

if (props.landing) {
  routerStore.setLanding(props.landing);
}

metaStore.setMetaInfo(props.initialMetaRooms, props.initialSelectedDate);

useTripPlannerViewModel();

const endLocationIngredient = computed(
  () => recipeStore.endLocationIngredient || null
);

watch(
  () => [
    recipeStore.recipe,
    recipeStore.pax,
    preferredDay,
    endLocationIngredient,
  ],
  async () => {
    if (!recipeStore.isRecipeCorrect) {
      return;
    }

    routerStore.isNavigating = true;

    await TripPlannerRoute.setQuery(
      {
        ingredients: recipeStore.recipe,
        pax: recipeStore.pax.rooms,
        selectedDate: preferredDay.value,
        selectedMonth: preferredMonth.value,
        affiliateId: metaStore.metaAffiliateId,
        clientId: metaStore.metaClientId,
        returnTransport:
          recipeStore.endLocationIngredient?.transportTypeToBeReached,
        aiTripId: props.aiTripId,
        publishedTripId: props.publishedTripId,
        customerOrigin: props.customerOrigin,
        modal: undefined,
        searchForPackageRates: recipeStore.searchForPackageRates,
        salesChannel: recipeStore.metaData?.salesChannel ?? undefined,
      },
      router
    );

    routerStore.isNavigating = false;
  },
  { immediate: true, deep: true }
);
</script>

<template>
  <router-view />
</template>
